module.exports = __webpack_public_path__ + "adventure-theme-park.png";